module.exports = __webpack_public_path__ + "static/media/Scope-12.facf74bb.png";